//=============================================================================
//                       <--- Developed By Icon Team ---> on 28 December 2020
//=============================================================================

// npm packages
import React, { useState, useCallback, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { CSVLink } from "react-csv";

// custom pages
import "assets/css/dashboard.css";
import Context from "context/context";
import Issued from "./Tabs/Issued";
import Redeemed from "./Tabs/Redeemed";
import EarnPending from "./Tabs/EarnPending";
import NonSales from "./Tabs/NonSales";
import Bonus from "./Tabs/Bonus";
import DashboardAPI from "apis/dashboard/dashboard";
import { useStyles } from "./styles";
import Filter from "./Filter/Filter";
import AvailablePointsCard from "./Components/AvailablePointsCard";
import {
  EarnedHeaders,
  RedeemedHeaders,
  PendingHeaders,
  EarnedPendingHeaders,
  RedeemedPendingHeaders,
  nonSalesHeaders,
  bonusHeaders,
} from "./Export/export";
import access from "config/access";
import PointsCard from "./Components/PointsCard";
import ViewMyStatement from "./ViewMyStatement";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Badge from "@material-ui/core/Badge";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import { useTranslation } from 'react-i18next';
// material-ui icons
import MoreVertIcon from "@material-ui/icons/MoreVert";

//ant-ui
import { Popover } from "antd";

//Helpers
import { pointsFormat, currencyFormat, dateFormat } from "helpers/dataFormat"

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: "0px 10px 10px 0px !important",
        height: 48,
      },
    },
  },
})(TextField);

const headers = {
  earned: EarnedHeaders,
  nonSales: nonSalesHeaders,
  bonus: bonusHeaders,
  redeemed: RedeemedHeaders,
  pending: PendingHeaders,
  pendingEarned: EarnedPendingHeaders,
  pendingRedeemed: RedeemedPendingHeaders,
};

const exportFileName = {
  earned: "Earned",
  nonSales: "NonSalesEarned",
  bonus: "Bonus",
  redeemed: "Redeemed",
  pending: "EarnedAndRedeemedPendingPoints",
  pendingEarned: "PendingEarned",
  pendingRedeemed: "PendingRedeemed",
};

const tabs = [
  {
    tabName: "Points Earned",
    tabLink: "earned",
  },
  {
    tabName: "Points Redeemed",
    tabLink: "redeemed",
  },
];

const earnedRadioTab = {
  earned: {
    tabName: "Sales",
    tabLink: "earned",
    tabValue: 0,
  },
  nonSales: {
    tabName: "Others",
    tabLink: "nonSales",
    tabValue: 1,
  },
};

const redeemedRadioTab = {
  redeemed: {
    tabName: "Approved",
    tabLink: "redeemed",
    tabValue: 2,
  },
  pendingRedeemed: {
    tabName: "Pending",
    tabLink: "pendingRedeemed",
    tabValue: 3,
  },
};

export default function Dashboard() {
  const { state, dispatch } = useContext(Context);
  const { getTransaction, doFilter, Export, getCustomerAccounts, getOrg } = DashboardAPI();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  // console.log(i18n.language,'raja')
  const [states, setstates] = useState({
    selectedTab: "earned",
    activeTab: 0,
    loyalityAccount: {},
    loading: false,
    earnedRadio: "earned",
    redeemedRadio: "redeemed",
    popover: false,
    startDate: new Date(),
    endDate: new Date(),
    date: false,
    dateValue: 0,
    businessName: [],
    searchValue: {},
    dialog: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const [startDate, setStartDate] = useState({
    earned: new Date(),
    redeemed: new Date(),
  });
  const [endDate, setEndDate] = useState({
    earned: new Date(),
    redeemed: new Date(),
  });
  const [date, setDate] = useState({
    earned: false,
    redeemed: false,
  });
  const [dateValue, setDateValue] = useState({
    earned: 0,
    redeemed: 0,
  });
  const [orgName, setOrgName] = useState({
    earned: [],
    redeemed: [],
  });
  const [expandPanel, setExpandPanel] = useState({
    earned: false,
    redeemed: false,
  });
  const [searchValue, setSearchValue] = useState({
    earned: "",
    redeemed: "",
  });
  const [filterCard, setFilterCard] = useState({
    earned: false,
    redeemed: false,
  });
  const [searchActive, setSearchActive] = useState({
    earned: false,
    redeemed: false,
  });
  const [filterActive, setFilterActive] = useState({
    earned: false,
    nonSales: false,
    redeemed: false,
  });
  const [customerAccounts, setCustomerAccounts] = useState({
    earned: [],
    redeemed: [],
  });
  const [billingAccounts, setBillingAccounts] = useState({
    earned: [],
    redeemed: [],
  });
  const [exportData, setExportData] = useState([]);
  const [offset, setOffset] = useState({
    earned: 1,
    nonSales: 1,
    redeemed: 1,
    pendingRedeemed: 1,
  });
  const [viewMore, setViewMore] = useState({
    earned: false,
    nonSales: false,
    redeemed: false,
    pendingRedeemed: false,
  });
  const [viewMoreEnd, setViewMoreEnd] = useState({
    earned: "",
    nonSales: "",
    redeemed: "",
    pendingRedeemed: "",
  });
  const [noData, setNoData] = useState({
    earned: false,
    nonSales: false,
    redeemed: false,
    pendingRedeemed: false,
  });
  const [customFilterDate, setCustomFilterDate] = useState({
    earned: false,
    redeemed: false,
  });
  const [currentTab, setCurrentTab] = useState(
    location?.state?.redeemed ? "pendingRedeemed" : "earned"
  );
  const [data, setData] = useState({
    earned: [],
    nonSales: [],
    redeemed: [],
    pendingRedeemed: [],
  });
  const [count, setCount] = useState({
    earned: 0,
    redeemed: 0,
  });
  const [loading, setLoading] = useState({
    earned: false,
    nonSales: false,
    redeemed: false,
    pendingRedeemed: false,
  });
  const [response, setResponse] = useState({
    earned: false,
    nonSales: false,
    redeemed: false,
    pendingRedeemed: false,
  });
  const [type, setType] = useState(1);
  const [disableDropdown, setDisableDropdown] = useState(false);

  useEffect(() => {
    if (location?.state?.redeemed) {
      setStates({
        selectedTab: "redeemed",
        redeemedRadio: "pendingRedeemed",
        activeTab: 3,
      });
      history.replace("/dashboard/dashboard", { redeemed: false });
    }
  }, []);

  useEffect(() => {
    handleMarketingAdminFunc();
  }, [state.ALA]);

  const handleMarketingAdminFunc = () => {
    if (access["myDashboard"]["loyalty"][state.userInfo.role]) {
      if (state?.ALA && Object.keys(state?.ALA).length > 0) {
        return;
      }
      return history.push("/dashboard/loyalty");
    }
  };

  // tabs switch case
  function setTab(tab) {
    switch (tab) {
      case 0:
        return (
          <Issued
            loyalityAccount={states.loyalityAccount}
            data={data[currentTab]}
            offset={offset}
            setOffset={setOffset}
            currentTab={currentTab}
            viewMore={viewMore}
            setViewMore={setViewMore}
            viewMoreEnd={viewMoreEnd}
            noData={noData}
            loading={loading[currentTab]}
            response={response[currentTab]}
          />
        );
      case 1:
        return (
          <NonSales
            loyalityAccount={states.loyalityAccount}
            data={data[currentTab]}
            offset={offset}
            setOffset={setOffset}
            currentTab={currentTab}
            viewMore={viewMore}
            setViewMore={setViewMore}
            viewMoreEnd={viewMoreEnd}
            noData={noData}
            loading={loading[currentTab]}
            response={response[currentTab]}
          />
        );
      case 2:
        return (
          <Redeemed
            loyalityAccount={states.loyalityAccount}
            data={data[currentTab]}
            offset={offset}
            setOffset={setOffset}
            currentTab={currentTab}
            viewMore={viewMore}
            setViewMore={setViewMore}
            viewMoreEnd={viewMoreEnd}
            noData={noData}
            loading={loading[currentTab]}
            response={response[currentTab]}
          />
        );
      case 3:
        return (
          <Redeemed
            loyalityAccount={states.loyalityAccount}
            data={data[currentTab]}
            offset={offset}
            setOffset={setOffset}
            currentTab={currentTab}
            viewMore={viewMore}
            setViewMore={setViewMore}
            viewMoreEnd={viewMoreEnd}
            noData={noData}
            loading={loading[currentTab]}
            response={response[currentTab]}
          />
        );
    }
  }

  const handleEarnedRadioChange = (e) => {
    setStates({
      earnedRadio: e.target.value,
      activeTab: earnedRadioTab[e.target.value]?.tabValue,
    });
    setCurrentTab(e.target.value);
  };

  const handleRedeemedRadioChange = (e) => {
    console.log({ e });
    setStates({
      redeemedRadio: e.target.value,
      activeTab: redeemedRadioTab[e.target.value]?.tabValue,
    });
    setCurrentTab(e.target.value);
  };

  // for breadcrumb
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "VIEW MY STATEMENTS"] });
  }, []);

  // handling points api call
  useEffect(() => {
    if (
      state.ALA &&
      Object.keys(state.ALA).length > 0 &&
      state.billingAccount &&
      Object.keys(state.billingAccount).length > 0
    ) {
      handleGetCustomerAccounts();
      handleGetOrg();
      handleSetBillingAccounts();
      return;
    }
  }, [state.ALA, state.billingAccount]);

  // setting filter data
  const handleGetCustomerAccounts = async () => {
    try {
      let values = state.ALA.loyalty_id;
      let res = await getCustomerAccounts(values);
      if (res) {
        let ca = res?.data?.map((c) => c.customer_account_number);
        dispatch({ type: "SET_CUSTOMERACCOUNTS", payload: ca });
        setCustomerAccounts({
          ...customerAccounts,
          earned: ca,
          redeemed: ca,
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // setting filter data
  const handleSetBillingAccounts = async () => {
    try {
      let value = [];
      value = [state.billingAccount?.customer_account_number];
      setBillingAccounts({
        ...billingAccounts,
        earned: value,
        redeemed: value,
      });
    } catch (e) {
      console.log({ e });
    }
  };

  // setting filter data
  const handleGetOrg = async () => {
    try {
      let res = await getOrg();
      if (res) {
        let org = res.data?.map((c) => c.loyalty_organization_name);
        dispatch({ type: "SET_ORG", payload: org });
        setOrgName({
          ...orgName,
          earned: org,
          redeemed: org,
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // handling api calls
  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      if (viewMoreEnd[currentTab] && viewMoreEnd[currentTab].length > 0) {
        return;
      }
      if (filterActive[currentTab]) {
        handleFilter();
        return;
      } else {
        handleGetTransaction();
        return;
      }
    }
  }, [state.ALA, currentTab, offset]);

  // transactions api func
  const handleGetTransaction = async () => {
    setLoading({ ...loading, [currentTab]: true });
    try {
      let values = {
        offset: (offset[currentTab] - 1) * 10,
        limit: 10,
        loyaltyId: state.ALA?.loyalty_id,
      };
      if (currentTab == "earned") {
        values = { ...values, type: "Earn", transaction_status: "Processed" };
      }
      if (currentTab == "nonSales") {
        values = {
          ...values,
          type: "Earn",
          transaction_status: "Processed",
          transaction_type: currentTab,
        };
      }
      if (currentTab == "redeemed") {
        values = { ...values, type: "Burn", transaction_status: "Processed" };
      }
      if (currentTab == "pendingRedeemed") {
        values = {
          ...values,
          type: "Burn",
          transaction_status: "Inprogress",
        };
      }
      let res = await getTransaction(values);
      if (res) {
        if (viewMore[currentTab]) {
          setData({
            ...data,
            [currentTab]: [...data[currentTab], ...res.data],
          });
          if (res.data.length < 6) {
            setViewMoreEnd({
              ...viewMoreEnd,
              [currentTab]: "End of data",
            });
          }
        } else {
          setData({ ...data, [currentTab]: res.data });
          setViewMoreEnd({ ...viewMoreEnd, [currentTab]: "" });
          if (res?.count == 0) {
            setNoData({ ...noData, [currentTab]: true });
          }
          if (res?.count > 0) {
            if (res.data.length <= 6 && res?.count <= 6) {
              setNoData({ ...noData, [currentTab]: true });
              setViewMoreEnd({
                ...viewMoreEnd,
                [currentTab]: "End of data",
              });
            }
          }
        }
        setResponse({ ...response, [currentTab]: true });
        setLoading({ ...loading, [currentTab]: false });
        return;
      }
    } catch (e) {
      console.log("Dashboard", { e });
    }
  };

  // filter api func
  const handleFilter = async () => {
    setLoading({ ...loading, [currentTab]: true });
    try {
      let values = {};
      var startOrderDate;
      var endOrderDate;

      values = {
        ...values,  
        transaction_status: "Processed",      
        offset: (offset[currentTab] - 1) * 10,
        limit: 10,
        loyaltyId: state.ALA?.loyalty_id,
      };

      // search value
      if (searchValue[currentTab]) {
        values = {
          ...values,
          searchValue: searchValue[currentTab],
        };
      }

      // filter date
      if (customFilterDate[currentTab]) {
        values = {
          ...values,
          startOrderDate: startDate[currentTab],
          endOrderDate: endDate[currentTab],
        };
      } else if (date[currentTab]) {
        startOrderDate = moment()
          .subtract(dateValue[currentTab], "d")
          .format("MM/DD/YYYY");
        endOrderDate = moment(new Date()).format("MM/DD/YYYY");
        values = {
          ...values,
          startOrderDate: startOrderDate,
          endOrderDate: endOrderDate,
        };
      }

      // Org name is selected
      if (orgName[currentTab] && orgName[currentTab].length > 0) {
        values = { ...values, orgName: orgName[currentTab] };
      }

      // Earned tab
      if (currentTab == "earned") {
        values = {
          ...values,
          type: "Earn",
          customerAccounts: customerAccounts[currentTab],
        };
      }
      // Redeemed tab
      if (currentTab == "redeemed") {
        values = {
          ...values,
          type: "Burn",
          billingAccounts: billingAccounts[currentTab],
        };
      }
      // Non sales tab
      if (currentTab == "nonSales") {
        values = {
          ...values,
          type: "Earn",
          transaction_type: currentTab,
        };
      }
      let res = await doFilter(values);

      if (res) {
        if (count[currentTab] == 0) {
          setCount({ ...count, [currentTab]: res.count });
        }
        if (viewMore[currentTab]) {
          setData({
            ...data,
            [currentTab]: [...data[currentTab], ...res.data],
          });
          if (res.data.length < 6) {
            setViewMoreEnd({
              ...viewMoreEnd,
              [currentTab]: "End of data",
            });
          }
        } else {
          setData({ ...data, [currentTab]: res.data });
          if (res?.count == 0) {
            setNoData({ ...noData, [currentTab]: true });
          }
          if (res?.count > 0) {
            if (res.data.length <= 6 && res?.count <= 6) {
              setNoData({ ...noData, [currentTab]: true });
              setViewMoreEnd({
                ...viewMoreEnd,
                [currentTab]: "End of data",
              });
            }
          }
        }
        setFilterCard({ ...filterCard, [currentTab]: false });
        setResponse({ ...response, [currentTab]: true });
        setLoading({ ...loading, [currentTab]: false });
      } else {
        setData({ ...data, [currentTab]: [] });
        setFilterCard({ ...filterCard, [currentTab]: false });
        setResponse({ ...response, [currentTab]: true });
        setLoading({ ...loading, [currentTab]: false });
      }
    } catch (e) {
      console.log("Dashboard", { e });
    }
  };

  // export api func
  const handleExport = async () => {
    try {
      let values = {};
      var startOrderDate;
      var endOrderDate;

      // If filter is not active
      if (!filterActive[currentTab]) {
        values = {
          condition: "GetAll",
          loyaltyId: state.ALA?.loyalty_id,
        };

        if (currentTab == "earned") {
          values = {
            ...values,
            type: "Earn",
            transaction_status: "Processed",
          };
        }
        if (currentTab == "nonSales") {
          values = {
            ...values,
            type: "Earn",
            transaction_status: "Processed",
            transaction_type: currentTab,
          };
        }
        if (currentTab == "redeemed") {
          values = {
            ...values,
            type: "Burn",
            // transaction_status: "Processed",
          };
        }
        if (currentTab == "pendingRedeemed") {
          values = {
            ...values,
            type: "Burn",
            transaction_status: "Inprogress",
          };
        }
      }

      // If filter is active
      if (filterActive[currentTab]) {
        values = {
          ...values,
          condition: "Filter",
          transaction_status: "Processed",
          loyaltyId: state.ALA?.loyalty_id,
        };

        // Earned
        if (currentTab == "earned") {
          values = {
            ...values,
            type: "Earn",
            customerAccounts: customerAccounts[currentTab],
          };
        }

        // Non sales
        if (currentTab == "nonSales") {
          values = {
            ...values,
            type: "Earn",
            transaction_status: "Processed",
            transaction_type: currentTab,
          };
        }

        // Redeemed
        if (currentTab == "redeemed") {
          values = {
            ...values,
            type: "Burn",
          };
          if (
            billingAccounts[currentTab] &&
            billingAccounts[currentTab].length > 0
          ) {
            values = {
              ...values,
              billingAccounts: billingAccounts[currentTab],
            };
          }
        }

        // Search value
        if (searchValue[currentTab] && searchValue[currentTab].length != 0) {
          values = {
            ...values,
            searchValue: searchValue[currentTab],
          };
        }

        // Filter date
        if (customFilterDate[currentTab]) {
          values = {
            ...values,
            startOrderDate: startDate[currentTab],
            endOrderDate: endDate[currentTab],
          };
        } else if (date[currentTab]) {
          startOrderDate = moment()
            .subtract(dateValue[currentTab], "d")
            .format("MM/DD/YYYY");
          endOrderDate = moment(new Date()).format("MM/DD/YYYY");
          values = {
            ...values,
            startOrderDate,
            endOrderDate,
          };
        }

        // Org name
        if (orgName[currentTab] && orgName[currentTab].length > 0) {
          values = { ...values, orgName: orgName[currentTab] };
        }
      }

      let res = await Export(values);
      if (res.data) {
        const convertedArray = (res?.data).map(obj => {
          return Object.keys(obj).reduce((acc, key) => {
            if (key == "points" || key == "points_redeemed" || key == "credits_applied") {
              if (i18n.language == "fr") {
                acc[key] = pointsFormat(obj[key], i18n.language) + String.fromCharCode(8203)
              } else {
                acc[key] = pointsFormat(obj[key], i18n.language)
              }
            }
            else if (key == 'extended_sales_amount' || key == 'credit_issued' || key == 'purchase_value') {
              acc[key] = currencyFormat(obj[key], i18n.language, state?.userInfo?.loyalty_organization_name)
            }
            else if (key == 'order_date' || key == 'reedemption_date' || key == 'date_of_transaction' || key == 'points_expiration_date') {
              if (i18n.language == "fr") {
                acc[key] = obj[key] ? dateFormat(obj[key], i18n.language) + String.fromCharCode(8203) : ""
              }
              else {
                acc[key] = obj[key] ? dateFormat(obj[key], i18n.language) : ""
              }
              if (key == "points_expiration_date" && state?.ALA?.["Loyalty_Account.points_not_expiring"] == true) {
                acc[key] = "N/A"
              }
            }
            else {
              acc[key] = t(obj[key])
            }
            return acc;
          }, {});
        });
        setExportData(convertedArray);
        return true;
      }
      return false;
    } catch (e) {
      console.log("Dashboard", { e });
    }
  };

  return (
    <React.Fragment>
           
      <ViewMyStatement page="Annual-Statment" setDisableDropdown={setDisableDropdown} />
      
    </React.Fragment>
  );
}
